const Title = ({ component = 'h1', ...props }) => {
  const Component = component;
  return <Component {...props} />;
};

export default Title;
